import type { QuestionData, SupplyOption } from "@/types/forms/question";

/** SUPPLIES_USED options; some responses send `stock_id`, others `stockId`. */
export function readSupplyOptions(
  data: QuestionData | undefined,
): SupplyOption[] {
  const raw = (data as { options?: unknown } | undefined)?.options;
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((entry) => {
    if (typeof entry !== "object" || entry === null) return [];
    const { label, stockId, stock_id } = entry as {
      label?: unknown;
      stockId?: unknown;
      stock_id?: unknown;
    };
    const id = typeof stockId === "string" ? stockId : stock_id;
    if (typeof id !== "string" || !id) return [];
    return [{ label: typeof label === "string" ? label : "", stockId: id }];
  });
}

/** Same rule as the backend: at least one supply, labels filled in and unique. */
export function supplyOptionsAreValid(options: SupplyOption[]): boolean {
  const labels = options.map((option) => option.label.trim().toLowerCase());
  return (
    labels.length > 0 &&
    labels.every(Boolean) &&
    new Set(labels).size === labels.length
  );
}
